import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { DaoComponent } from "./components/Dao";
import { DeployDao } from "./components/DeployDao";
import { Footer, Header } from "./components/Header";
import { IndexPage } from "./components/IndexPage";
import {
  AnalyticsContext,
  useAnalyticsScreenView,
  useCreateAnalytics,
} from "./hooks/analytics";
import { AppThemeProvider } from "./Theme";

function Layout() {
  useAnalyticsScreenView();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Header />
      <Container component="main" sx={{ mt: 4, mb: 2 }} maxWidth="sm">
        <Routes>
          <Route path=":address/*" element={<DaoComponent />}></Route>
          <Route path="deploy" element={<DeployDao />} />
          <Route index element={<IndexPage />} />
        </Routes>
      </Container>
      <Footer />
    </Box>
  );
}

const client = new QueryClient();

function App() {
  const analytics = useCreateAnalytics();

  return (
    <TonConnectUIProvider
      manifestUrl={`${window.location.origin}/tonconnect-manifest.json`}
    >
      <QueryClientProvider client={client}>
        <BrowserRouter>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <AppThemeProvider>
              <AnalyticsContext.Provider value={analytics}>
                <Layout />
              </AnalyticsContext.Provider>
            </AppThemeProvider>
          </LocalizationProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </TonConnectUIProvider>
  );
}

export default App;
